import { isPhone } from '@helpers';
import i18n from 'i18n-js';

export const MACHINES_NOW_OVERVIEW_BLOCK_CONFIG = {
  maxWidth: 948,
  blockBgColor: 'Background/Light/Field',
  paddingHorizontal: 15,
  gapBetweenBlocks: isPhone ? 15 : 18,
};

export const TOP_BLOCK_CONFIG = {
  topBlockHeight: 200,
  paddingVertical: 7,
  ncFileNamePaddingBottom: 4,
  changeNCFileTypeButtonPaddingBottom: 9,
  gapBetweenInfoLines: 3,
  linkIconSize: 24,
};

export const BATCH_BLOCK_CONFIG = {
  height: 233,
  paddingVertical: 15,
  legendBulletSize: 8,
  readyPcsBreakpoint: 20,
  timelineHeight: 6,
  overlappedBulletColor: 'Chart/Light/Warning',
  notFinishedBulletColor: 'Background/Light/Chart',
  finishedBulletColor: 'Label/Light/Primary',
};

export const TIME_DELIMITER = ':';

export const NC_FILE_BLOCK_MAX_HEIGHT = 900;
export const NC_FILE_MIN_VISIBLE_ROWS = 10;
export const NC_FILE_ESTIMATED_ROW_HEIGHT = 29;
export const NC_FILE_LARGE_MODE_THRESHOLD = NC_FILE_MIN_VISIBLE_ROWS * NC_FILE_ESTIMATED_ROW_HEIGHT;
export const GAP_BETWEEN_TIME_BLOCKS = 36;

export const TIME_CONFIG = {
  placeholder: `--${TIME_DELIMITER}--`,
  format: 'HH:mm',
  hmsFormatDigitFont: 'Time 2',
} as const;

export const OEE_TOOLS_BLOCK_CONFIG = {
  height: 98,
  gapBetweenLines: 6,
};

// Constants derived from activeLiveScreen.svg (viewBox 60x60)
export const ACTIVE_MACHINE_ICON_CONFIG = {
  // Outer ring
  outerSize: 60,
  outerBorderWidth: 2,
  // Inner background circle
  innerBgRadius: 26,
  innerBgOpacity: 0.15,
  // Target outer ring
  targetOuterRadius: 11,
  targetOuterBorderWidth: 2.74,
  // Target inner ring (animated)
  targetInnerRadius: 4.1,
  targetInnerBorderWidth: 2.64,
} as const;

export const ACTIVE_MACHINE_ICON_ANIMATION_CONFIG = {
  duration: 2000,
  minScale: 0.6,
  maxScale: 1,
  startOpacity: 0.4,
  endOpacity: 1,
  iconSize: 60,
  activeIconName: 'activeLiveScreen',
} as const;

export const SPINNING_ICON_CONFIG = {
  duration: 4000,
  spinningIconName: 'changeLiveScreen',
} as const;

export const ACTIVE_BULLET_ANIMATION_CONFIG = {
  duration: ACTIVE_MACHINE_ICON_ANIMATION_CONFIG.duration,
  startOpacity: ACTIVE_MACHINE_ICON_ANIMATION_CONFIG.startOpacity,
} as const;

export const END_TIME_TEXT_VARIANTS = {
  end: i18n.t('END'),
  paused: i18n.t('PAUSED'),
  expectedEnd: i18n.t('EXPECTED END'),
};

export const BATCH_NOT_AVAILABLE_TEXT = {
  atAll: i18n.t('Batch Not Available'),
  forShortTime: `${i18n.t('Retrieving Batch Information')}...`,
};

export const BATCH_NOT_AVAILABLE_TIMEOUT_IN_MS = 15 * 1000;
export const ELAPSED_TIME_BREAKPOINT = 60 * 60;
